import React from 'react';
import { Link, useHistory } from "react-router-dom";
import { useEffect, useGlobal, useState } from 'reactn';
import { useTranslation } from 'react-i18next';

import useLocalStorage from "stores/useLocalStorage.js";
import { useApi } from 'stores/api';
import { PAYMENT_TYPE } from 'stores/const';
import { useAuth } from 'stores/auth';

import { SvgImg } from 'components/SvgImg';
import Stepper from 'components/Stepper';
import FixedBottom from 'components/FixedBottom';

const BWPayment = (props) => {
    const auth = useAuth();
    let history = useHistory();
    const { t } = useTranslation(['wizard-payment']);
    const [LSObjectDetailsMap] = useLocalStorage('ls_odm');
    const [LSIsGuestBooking] = useLocalStorage('ls_igb');
    const [objectDetails, setObjectDetails] = useGlobal('objectDetails');
    const [orderId] = useGlobal('orderId');
    const [orderData] = useGlobal('orderData');
    const [modalProps, setModalProps] = useGlobal('modalProps');
    const api = useApi();

    const [customerPaymentMethods, setCustomerPaymentMethods] = useState([]);
    const [paymentType, setPaymentType] = useState('');

    const buPaymentTypes = objectDetails?.businessUnit?.BusinessUnitPaymentMethod;

    const currency = () => orderData?.Currency_Name;
    const onClickConfirmation = async (e) => {
        e.preventDefault();
        if (!paymentType) {
            setModalProps({ ...modalProps, showModal: true, messages: [t("msgSelectPaymentType")] });
            return;
        }
        let result;
        // if (LSIsGuestBooking) {
        //     result = await api.setGuestData(orderId);
        //     if (!result) return;
        // }
        const isCC = paymentType === PAYMENT_TYPE.CREDITCARD;
        result = await api.bookOrder(orderId, paymentType, isCC ? 'LesseeOrderPRM' : null, orderData.TotalPrice);
        if (result) {
            if (isCC && orderData.TotalPrice > 0) {
                api.processCCGWRequest(result);
            }
            else {
                history.push('/wizard/confirmation');
            }
        }
    };

    useEffect(() => {
        const parseURLParams = () => {
            const qsp = new URLSearchParams(document.location.search);
            const errorCode = qsp.get("errorCode") || '';
            const errorMessage = qsp.get("errorMessage") || '';
            if (errorCode && errorMessage) {
                setModalProps({
                    ...modalProps,
                    showModal: true,
                    messages: [errorCode + ": " + errorMessage]
                });
            }
        }
        parseURLParams();
    }, [])

    const checkAndSetPaymentType = () => {
        if (buPaymentTypes && buPaymentTypes.length === 1) {
            setPaymentType(buPaymentTypes[0].Id);
        }
    }

    useEffect(() => {
        if (auth.user) {
            const authUser = auth.user;
            if (authUser.CustomerOrganizationBusinessPartner && authUser.CustomerOrganizationBusinessPartner.length > 0) {
                const cbp = authUser.CustomerOrganizationBusinessPartner[0];
                if (cbp.CustomerGroupPaymentMethods && cbp.CustomerGroupPaymentMethods.length > 0) {
                    const buIds = buPaymentTypes?.map(item => item.Id) ?? [];
                    const cbpm = cbp.CustomerGroupPaymentMethods.filter(item => !buIds.includes(item.refPaymentMethodId));
                    if (((buPaymentTypes?.length ?? 0) + cbpm.length) === 1) {
                        if(cbpm.length === 1) {
                            setPaymentType(cbpm[0].refPaymentMethodId);
                        } else {
                            checkAndSetPaymentType();
                        }
                    }
                    setCustomerPaymentMethods(cbpm);
                } else {
                    checkAndSetPaymentType();
                }
            } else {
                checkAndSetPaymentType();
            }
        }
    }, [auth.user, buPaymentTypes])

    useEffect(() => {
        if (orderData && !objectDetails) {
            let firstKey = Object.keys(LSObjectDetailsMap)[0];
            if (firstKey) {
                console.log('firstobject payment methods');
                console.log(LSObjectDetailsMap[firstKey].businessUnit.BusinessUnitPaymentMethod);
                setObjectDetails(LSObjectDetailsMap[firstKey]);
            }
        }
    }, [orderData])

    return (
        <>
            <Stepper activeStep="payment" />
            {orderData && objectDetails && <section className="wizard-container booking-view">
                <div className="wrapper">
                    <div className="row wizard-content">
                        <div className="column-12">
                            <h3 className="mali-blue">{t("payment")}</h3>

                            <div className="payment-container">
                                <div className="paymentType-container">
                                    {buPaymentTypes && buPaymentTypes.map(payType => {
                                        if (payType.Id === PAYMENT_TYPE.PICKUP) {
                                            return (
                                                <div key={payType.id}
                                                    className={"paymentType-option" + (payType.Id === paymentType ? " selected" : "")}
                                                    onClick={event => setPaymentType(payType.Id)}>
                                                    <div className="paymentType-icon">
                                                        <SvgImg className="svg cash-icon" src="/clients/standard/release/assets/content/icons/cash.svg" />
                                                    </div>
                                                    <div className="paymentType-text">
                                                        <div className="paymentType-title">
                                                            {payType.Name}
                                                        </div>
                                                        <div className="paymentType-explainText">
                                                            {payType.Description}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        if (payType.Id === PAYMENT_TYPE.BANKTRANSFER) {
                                            return (
                                                <div key={payType.id}
                                                    className={"paymentType-option" + (payType.Id === paymentType ? " selected" : "")}
                                                    onClick={event => setPaymentType(payType.Id)}>
                                                    <div className="paymentType-icon">
                                                        <SvgImg className="svg bankTransfer-icon" src="/clients/standard/release/assets/content/icons/bank-transfer.svg" />
                                                    </div>
                                                    <div className="paymentType-text">
                                                        <div className="paymentType-title">
                                                            {payType.Name}
                                                        </div>
                                                        <div className="paymentType-explainText">
                                                            {payType.Description}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        if (payType.Id === PAYMENT_TYPE.CREDITCARD) {
                                            return (
                                                <div key={payType.Id}
                                                    className={"paymentType-option" + (payType.Id === paymentType ? " selected" : "")}
                                                    onClick={event => setPaymentType(payType.Id)}>
                                                    <div className="paymentType-icon">
                                                        <SvgImg className="svg creditCard-icon" src="/clients/standard/release/assets/content/icons/credit-card.svg" />
                                                    </div>
                                                    <div className="paymentType-text">
                                                        <div className="paymentType-title">
                                                            {payType.Name}
                                                        </div>
                                                        <div className="paymentType-explainText">
                                                            {payType.Description}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        if (payType.Id === PAYMENT_TYPE.PERIODICALINVOICE) {
                                            return (
                                                <div key={payType.Id}
                                                    className={"paymentType-option" + (payType.Id === paymentType ? " selected" : "")}
                                                    onClick={event => setPaymentType(payType.Id)}>
                                                    <div className="paymentType-icon">
                                                        <SvgImg className="svg periodicBill-icon" src="/clients/standard/release/assets/content/icons/periodic-bill.svg" />
                                                    </div>
                                                    <div className="paymentType-text">
                                                        <div className="paymentType-title">
                                                            {payType.Name}
                                                        </div>
                                                        <div className="paymentType-explainText">
                                                            {payType.Description}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    })}
                                    {
                                        customerPaymentMethods.map(payType => {
                                            if (payType.refPaymentMethodId === PAYMENT_TYPE.PICKUP) {
                                                return (
                                                    <div key={payType.refPaymentMethodId}
                                                        className={"paymentType-option" + (payType.refPaymentMethodId === paymentType ? " selected" : "")}
                                                        onClick={event => setPaymentType(payType.refPaymentMethodId)}>
                                                        <div className="paymentType-icon">
                                                            <SvgImg className="svg cash-icon" src="/clients/standard/release/assets/content/icons/cash.svg" />
                                                        </div>
                                                        <div className="paymentType-text">
                                                            <div className="paymentType-title">
                                                                {payType.Name}
                                                            </div>
                                                            <div className="paymentType-explainText">
                                                                {payType.Description}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            if (payType.refPaymentMethodId === PAYMENT_TYPE.BANKTRANSFER) {
                                                return (
                                                    <div key={payType.refPaymentMethodId}
                                                        className={"paymentType-option" + (payType.refPaymentMethodId === paymentType ? " selected" : "")}
                                                        onClick={event => setPaymentType(payType.refPaymentMethodId)}>
                                                        <div className="paymentType-icon">
                                                            <SvgImg className="svg bankTransfer-icon" src="/clients/standard/release/assets/content/icons/bank-transfer.svg" />
                                                        </div>
                                                        <div className="paymentType-text">
                                                            <div className="paymentType-title">
                                                                {payType.Name}
                                                            </div>
                                                            <div className="paymentType-explainText">
                                                                {payType.Description}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            if (payType.refPaymentMethodId === PAYMENT_TYPE.CREDITCARD) {
                                                return (
                                                    <div key={payType.refPaymentMethodId}
                                                        className={"paymentType-option" + (payType.refPaymentMethodId === paymentType ? " selected" : "")}
                                                        onClick={event => setPaymentType(payType.refPaymentMethodId)}>
                                                        <div className="paymentType-icon">
                                                            <SvgImg className="svg creditCard-icon" src="/clients/standard/release/assets/content/icons/credit-card.svg" />
                                                        </div>
                                                        <div className="paymentType-text">
                                                            <div className="paymentType-title">
                                                                {payType.Name}
                                                            </div>
                                                            <div className="paymentType-explainText">
                                                                {payType.Description}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            if (payType.refPaymentMethodId === PAYMENT_TYPE.PERIODICALINVOICE) {
                                                return (
                                                    <div key={payType.refPaymentMethodId}
                                                        className={"paymentType-option" + (payType.refPaymentMethodId === paymentType ? " selected" : "")}
                                                        onClick={event => setPaymentType(payType.refPaymentMethodId)}>
                                                        <div className="paymentType-icon">
                                                            <SvgImg className="svg periodicBill-icon" src="/clients/standard/release/assets/content/icons/periodic-bill.svg" />
                                                        </div>
                                                        <div className="paymentType-text">
                                                            <div className="paymentType-title">
                                                                {payType.Name}
                                                            </div>
                                                            <div className="paymentType-explainText">
                                                                {payType.Description}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })
                                    }
                                </div>
                                {objectDetails && paymentType === PAYMENT_TYPE.BANKTRANSFER &&
                                    <div className="payment-info">
                                        <h4>{t("bankAccount")}</h4>
                                        <div className="payment-account">
                                            {objectDetails.businessUnit.BankAccountDescription}
                                        </div>
                                        <h4>{t("bankPaymentConditions")}</h4>
                                        <div className="payment-conditions">
                                            {objectDetails.businessUnit.BankAccountPaymentInstruction}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    {/* <div className="row main-wizardbtns-container">
                        <div className="column-6">
                            <a className="back" onClick={navigation.goBWReview}><i className="fa fa-arrow-left" aria-hidden="true"></i> {translate("back", "Zurück")}</a>
                        </div>
                        <div className="column-6">
                            <a id="btn-fwd-bwpay" className="forward" onClick={vPayment.finishBooking}>{translate("firmlyBookFor", "Verbindlich Buchen für")} {currency} {fmtPrice(rentalTransaction.totalDiscountedPrice)} <i className="fa fa-check" aria-hidden="true"></i></a>
                        </div>
                    </div> */}

                </div>
            </section>}
            {orderData && <FixedBottom>
                <div className="wrapper">
                    <div className="row fixedBottom-content">
                        <div className="column-8 fixedBottom-right">
                            <div className="fixedBottom-buttons btn-forward">
                                <Link to={`/wizard/confirmation`} onClick={onClickConfirmation} className="book-object">
                                    {t("bookBindingly")} {currency()} {orderData.TotalPrice} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div className="column-4 fixedBottom-left">
                            <div className="fixedBottom-buttons btn-back">
                                {<Link to={`/wizard/overview`} className="book-object">
                                    <i className="fa fa-arrow-left" aria-hidden="true"></i> {t("overview")}
                                </Link>}
                            </div>
                        </div>
                    </div>
                </div>
            </FixedBottom>}
        </>
    );
}

export default BWPayment;